import React from 'react';
import PropTypes from 'prop-types';

import InstagramLogo from '../../../assets/images/instagram-logo.png';

const InstagramLink = ({ user }) => {
  if (!user) return null;
  return (
    <a className="c-instagram-link" href={`https://www.instagram.com/${user}`} target="_blank" onClickCapture={e => e.stopPropagation()}>
      <img src={InstagramLogo} alt="" />
    </a>
  );
};
InstagramLink.propTypes = {
  user: PropTypes.string,
};
InstagramLink.defaultProps = {
  user: '',
};

export default InstagramLink;



// WEBPACK FOOTER //
// ./src/app/components/InstagramLink.jsx